import * as types from '../constants/actionTypes';
import axios from 'axios/index';

// example of a thunk using the redux-thunk middleware
export function requestCartItems() {
  return function (dispatch) {
    // thunks allow for pre-processing actions, calling apis, and dispatching multiple actions
    // in this case at this point we could call a service that would persist the fuel savings
    return dispatch({
      type: types.REQUEST_CART_ITEMS
    });
  };
}

export function receiveCartItems(shoppingCart) {
  return {
    type: types.RECEIVE_CART_ITEMS,
    shoppingCart
  };
}

export function updateCartItemQty(id, qty) {
  return function (dispatch) {
    axios.post(`${ROOT_URL}/api/update-shopping-cart-item-qty?id=${id}&qty=${qty}`, {id, qty}, {
      withCredentials: true
    }).then(response => {
      dispatch(receiveCartItems(response.data));
    });
  };
}

export function fetchCartItems() {
  // Thunk middleware knows how to handle functions.
  // It passes the dispatch method as an argument to the function,
  // thus making it able to dispatch actions itself.

  return function (dispatch) {
    // First dispatch: the app state is updated to inform
    // that the API call is starting.

    dispatch(requestCartItems());

    // The function called by the thunk middleware can return a value,
    // that is passed on as the return value of the dispatch method.

    // In this case, we return a promise to wait for.
    // This is not required by thunk middleware, but it is convenient for us.

    return axios.get(`${ROOT_URL}/api/get-shopping-cart?_=${new Date().getTime()}`, { withCredentials: true })
      .then(response => {
        dispatch(receiveCartItems(response.data));
      });
  };
}

export function requestPreviouslyPurchasedItems() {
  return function (dispatch) {
    return dispatch({
      type: types.REQUEST_PREVIOUSLY_PURCHASED_ITEMS
    });
  };
}

export function receivePreviouslyPurchasedItems(response) {
  return {
    type: types.RECEIVE_PREVIOUSLY_PURCHASED_ITEMS,
    items: response.items
  };
}

export function fetchPreviouslyPurchasedItems() {
  return function (dispatch) {
    dispatch(requestPreviouslyPurchasedItems());

    return axios.get(`${ROOT_URL}/api/get-previously-purchased-items`, {
      withCredentials: true
    }).then(response => {
      dispatch(receivePreviouslyPurchasedItems(response.data));
    });
  };
}

export function requestRelatedInkItems() {
  return function (dispatch) {
    return dispatch({
      type: types.REQUEST_RELATED_INK_ITEMS
    });
  };
}

export function receiveRelatedInkItems(response) {
  return {
    type: types.RECEIVE_RELATED_INK_ITEMS,
    items: response.items
  };
}

export function fetchRelatedInkItems() {
  return function (dispatch) {
    dispatch(requestRelatedInkItems());

    return axios.get(`${ROOT_URL}/api/get-related-items?type=ink`, {
      withCredentials: true
    }).then(response => {
      dispatch(receiveRelatedInkItems(response.data));
    });
  };
}

export function requestRelatedMaintenanceItems() {
  return function (dispatch) {
    return dispatch({
      type: types.REQUEST_RELATED_MAINTENANCE_ITEMS
    });
  };
}

export function receiveRelatedMaintenanceItems(response) {
  return {
    type: types.RECEIVE_RELATED_MAINTENANCE_ITEMS,
    items: response.items
  };
}

export function fetchRelatedMaintenanceItems() {
  return function (dispatch) {
    dispatch(requestRelatedMaintenanceItems());

    return axios.get(`${ROOT_URL}/api/get-related-items?type=maintenance`, {
      withCredentials: true
    }).then(response => {
      dispatch(receiveRelatedMaintenanceItems(response.data));
    });
  };
}

export function requestSavedItems() {
  return function (dispatch) {
    return dispatch({
      type: types.REQUEST_SAVED_ITEMS
    });
  };
}

export function receiveSavedItems(response) {
  return {
    type: types.RECEIVE_SAVED_ITEMS,
    items: response.items
  };
}

export function fetchSavedItems() {
  return function (dispatch) {
    dispatch(requestSavedItems());

    return axios.get(`${ROOT_URL}/api/get-saved-items`, {
      withCredentials: true
    }).then(response => {
      dispatch(receiveSavedItems(response.data));
    });
  };
}

export function addToSavedCart(id) {
  return function (dispatch) {

    axios.post(`${ROOT_URL}/api/add-to-saved-items?id=${id}`, { id }, {
      withCredentials: true
    }).then(response => {
      dispatch(receiveSavedItems(response.data));
    });
  };
}

export function removeFromSavedCart(id) {
  return function (dispatch) {

    axios.post(`${ROOT_URL}/api/remove-from-saved-items?id=${id}`, { id }, {
      withCredentials: true
    }).then(response => {
      dispatch(receiveSavedItems(response.data));
    });
  };
}

export function addToCart(id, callback = () => {}) {
  return function (dispatch) {

    axios.post(`${ROOT_URL}/api/add-to-cart?id=${id}`, { id }, {
      withCredentials: true
    }).then(response => {
      callback();
    });
  };
}

export function addToMyProducts(id) {
  return function (dispatch) {

    axios.post(`${ROOT_URL}/api/add-to-my-products?id=${id}`, { id }, {
      withCredentials: true
    }).then(response => {
      dispatch(receiveSavedItems(response.data));
    });
  };
}
